import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_3 = {
  key: 0,
  class: "grid gap-4 xl:gap-8 md:grid-cols-2 lg:grid-cols-3"
}
const _hoisted_4 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 xl:gap-8 lg:grid-cols-3"
}
const _hoisted_5 = {
  key: 1,
  class: "flex h-screen -mt-40"
}
const _hoisted_6 = { class: "mx-auto my-auto flex flex-col" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"10rem"},
  class: "material-icons-outlined opacity-10 mx-auto"
}, " assignment ", -1)
const _hoisted_8 = { class: "opacity-40 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventParticipationPreview = _resolveComponent("EventParticipationPreview")!
  const _component_SkeletonCard = _resolveComponent("SkeletonCard")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_VueEternalLoading = _resolveComponent("VueEternalLoading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.firstLoading || _ctx.mainStore.examParticipations.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.firstLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainStore.examParticipations, (participation) => {
                  return (_openBlock(), _createBlock(_component_EventParticipationPreview, {
                    key: 'exam-participation-' + participation.id,
                    participation: participation
                  }, null, 8, ["participation"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_SkeletonCard, { class: "h-44" }),
                _createVNode(_component_SkeletonCard, { class: "h-44" }),
                _createVNode(_component_SkeletonCard, { class: "h-44" })
              ])),
          (!_ctx.firstLoading)
            ? (_openBlock(), _createBlock(_component_VueEternalLoading, {
                key: 2,
                load: _ctx.onLoadMore,
                class: "mt-8",
                "is-initial": _ctx.isInitialInfiniteLoad,
                "onUpdate:is-initial": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isInitialInfiniteLoad) = $event))
              }, {
                loading: _withCtx(() => [
                  _createVNode(_component_Spinner)
                ]),
                "no-more": _withCtx(() => [
                  _createTextVNode("   ")
                ]),
                _: 1
              }, 8, ["load", "is-initial"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t("student_course_dashboard.no_exams")), 1)
          ])
        ]))
  ]))
}